import React from 'react';
import $ from 'jquery-slim';
import QuestionDetailsComponent from './QuestionDetailsComponent';
import { stripHtml } from 'string-strip-html';
import Select from 'react-select';

class DropdownListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
    };
  }

  componentDidUpdate(prevProps) {
    const { answer, conduct, question } = this.props;
    const select = document.getElementById(
      `dropdownlist${this.props.question.elementKey}`
    );

    // 1. ถ้ามีการเปลี่ยนแปลง countryOptions → get options ใหม่
    if (
      question.elementKey === 'FE81A26D-2A24-4397-92C4-5AA0FFFF48AF' &&
      prevProps.conduct.countryOptions !== conduct.countryOptions
    ) {
      this.getOptions().then((options) => {
        this.setState({ options });
      });
    }

    // 2. จัดการ select ค่า
    if (answer.value) {
      $.each($(select).find('option'), function (i, v) {
        if ($(v).val() * 1 === 0) {
          $(v).remove();
        }
      });
      $(select).val(answer.value);
    } else {
      $(select).val(0);
    }
  }
  async componentDidMount() {
    const { answer } = this.props;
    const { questionContent } = this.props.question;
    const select = document.getElementById(
      `dropdownlist${this.props.question.elementKey}`
    );

    const options = await this.getOptions();
    this.setState({ options });

    if (answer.value) {
      $(select).val(answer.value);
    } else {
      //wait for defualt value
      $(select).prepend(
        `<option style='display:none;' selected value='0'>${
          questionContent && !questionContent.helpText ? '' : ''
        }</option>`
      );

      //  const { choices } = this.props.question;
      $(select).val(0);
    }
  }

  switchLanguages(publishKey, elementKey, targetValue) {
    let switchLangKey = '92BBA268-D3DA-406E-82E3-E32576CA2668';
    let engLangKey = '1EEBFC48-A1AF-4A09-858C-8A73CAFC6B0F';
    let thaiLangKey = '3D0ECB33-590B-45D7-BBBE-FE84FE1F820C';

    if (elementKey === switchLangKey) {
      if (targetValue === thaiLangKey) {
        let thaiLanguageID = 1;
        this.props.setLanguages(publishKey, thaiLanguageID);
      } else if (targetValue === engLangKey) {
        let engLanguageID = 2;
        this.props.setLanguages(publishKey, engLanguageID);
      }
    }
  }

  // on load set default value
  setDefaultValue() {
    const { choices } = this.props.question;
    for (let i = 0; i < choices.length; i++) {
      if (choices[i].selectChoiceDefault) {
        this.switchLanguages(
          this.props.publishKey,
          this.props.question.elementKey,
          choices[i].elementKey
        );
        this.props.setAnswer(this.props, choices[i].elementKey);
        return choices[i].choiceText;
      }
    }
  }

  getOptions() {
    const { conduct, question } = this.props;
    const { elementKey, choices } = question;

    if (elementKey === 'FE81A26D-2A24-4397-92C4-5AA0FFFF48AF') {
      return Promise.resolve(
        (conduct.countryOptions || []).map((item) => ({
          value: String(item.value),
          label: item.label,
        }))
      );
    } else {
      return Promise.resolve(
        (choices || []).map((choice) => ({
          value: choice.elementKey,
          label: stripHtml(choice.choiceText).result,
        }))
      );
    }
  }
  getDefaultValue() {
    const { conduct, question, answer } = this.props;
    const { elementKey, choices } = question;

    if (elementKey === 'FE81A26D-2A24-4397-92C4-5AA0FFFF48AF') {
      const selected = conduct.countryOptions.find((c) => {
        return c.value === answer.value;
      });
      if (selected) {
        return {
          value: selected.value,
          label: selected.label,
        };
      }
    } else {
      const selected = choices.find(
        (c) => c.elementKey === this.props.answer.value
      );
      if (selected) {
        return {
          value: selected.elementKey,
          label: stripHtml(selected.choiceText).result,
        };
      }

      const defaultChoice = choices.find((c) => c.selectChoiceDefault);
      if (defaultChoice) {
        this.switchLanguages(
          this.props.publishKey,
          this.props.question.elementKey,
          defaultChoice.elementKey
        );
        this.props.setAnswer(this.props, defaultChoice.elementKey);
        return {
          value: defaultChoice.elementKey,
          label: stripHtml(defaultChoice.choiceText).result,
        };
      }

      return null;
    }
  }

  render() {
    const { elementKey } = this.props.question;
    const { answer } = this.props;
    const { value } = answer;
    const { helpText } = this.props.question.questionContent;
    const isSearchable =
      elementKey === 'FE81A26D-2A24-4397-92C4-5AA0FFFF48AF' ? true : false;
    let options = this.state.options;
    if (elementKey === 'B00D52D2-56BE-4F03-A189-0FD799C764A4') {
      options = options.sort((a, b) => a.label.localeCompare(b.label));
    }
    return (
      <div
        id={`${this.props.question.elementKey}`}
        className={`question dropdown`}
      >
        <QuestionDetailsComponent {...this.props} />
        <div className="question_element">
          <label className={value ? 'has-value' : ''}>{helpText}</label>
          <Select
            id={`dropdownlist${this.props.question.elementKey}`}
            className="select2"
            //sort options by label
            options={options}
            // options={this.state.options}
            value={this.getDefaultValue()}
            placeholder={helpText}
            onChange={(selectedOption) => {
              if (selectedOption) {
                this.switchLanguages(
                  this.props.publishKey,
                  this.props.question.elementKey,
                  selectedOption.value
                );
                this.props.setAnswer(this.props, selectedOption.value);
              }
            }}
            isSearchable={isSearchable}
            styles={{
              control: (provided, state) => ({
                ...provided,
                border: '1px solid #919eab33',
                borderRadius: '8px',
                height: '54px',
                color: '#637381',
                padding: '0 4px',
                boxShadow: 'none',
                '&:hover': {
                  borderColor: '#919eab',
                },
              }),
              singleValue: (provided) => ({
                ...provided,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: '#637381',
              }),
              dropdownIndicator: (provided) => ({
                ...provided,
                padding: '0 4px',
                svg: {
                  width: 16,
                  height: 16,
                  fill: '#637381',
                },
              }),
              menu: (provided) => ({
                ...provided,
                zIndex: 9999,
              }),
            }}
          />
        </div>
      </div>
    );
  }
}

export default DropdownListComponent;
